import { getImage, IGatsbyImageData } from "gatsby-plugin-image"

const getGatsbyImage = (node): IGatsbyImageData =>
  getImage(node) as IGatsbyImageData

export default getGatsbyImage
